
import { Property, AppNotification } from '../types';

export const generateNotifications = (properties: Property[]): AppNotification[] => {
    const notifications: AppNotification[] = [];
    const today = new Date();
    const currentMonth = today.getMonth(); // 0-11

    // 1. IMI TAX ALERTS (May, August, November in Portugal usually)
    // Simplified logic: Warn in May and November
    if (currentMonth === 4 || currentMonth === 10) {
        notifications.push({
            id: 'imi-alert-' + currentMonth,
            title: 'IMI Tax Payment',
            message: 'Municipal Property Tax (IMI) payment window is likely open. Check your Portal das Finanças.',
            date: today.toISOString().split('T')[0],
            type: 'Warning',
            category: 'Tax',
            isRead: false
        });
    }

    // 2. PROPERTY SPECIFIC CHECKS
    properties.forEach(p => {
        if (p.isDeleted) return;

        // Lease Expiry (60 days notice)
        if (p.leaseEnd) {
            const leaseDate = new Date(p.leaseEnd);
            const diffTime = leaseDate.getTime() - today.getTime();
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays > 0 && diffDays <= 60) {
                notifications.push({
                    id: `lease-${p.id}`,
                    title: 'Lease Expiring Soon',
                    message: `Lease for ${p.address} ends in ${diffDays} days. Review renewal or termination notice.`,
                    date: today.toISOString().split('T')[0],
                    type: 'Critical',
                    category: 'Lease',
                    isRead: false
                });
            } else if (diffDays < 0) {
                 notifications.push({
                    id: `lease-exp-${p.id}`,
                    title: 'Lease Expired',
                    message: `Lease for ${p.address} expired on ${p.leaseEnd}. Update status if renewed.`,
                    date: today.toISOString().split('T')[0],
                    type: 'Info',
                    category: 'Lease',
                    isRead: false
                });
            }
        }

        // Insurance Expiry (30 days)
        if (p.insuranceExpiry) {
            const insDate = new Date(p.insuranceExpiry);
            const diffTime = insDate.getTime() - today.getTime();
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays > 0 && diffDays <= 30) {
                notifications.push({
                    id: `ins-${p.id}`,
                    title: 'Insurance Renewal',
                    message: `Multi-risk insurance for ${p.address} expires in ${diffDays} days.`,
                    date: today.toISOString().split('T')[0],
                    type: 'Warning',
                    category: 'Insurance',
                    isRead: false
                });
            }
        }
    });

    return notifications;
};
